


import React from 'react'
import './CSS/SimpleCaseStudy.css'



const SimpleCaseStudy = () => {



  return (
    <>

    <div className='simple-case-study-container'>
    <div className='simple-case-study-wrapper'>

            <div><h3>ShoeStore E-commerce Case Study</h3></div>
    </div>


    <div className='simple-case-overview-wrapper'>
        <div><h3> Why Did I Created This Project</h3></div>

        <div className='simple-case-text-wrapper'>
            <div><p> This project was created because of the experience I wanted to have the user to have that 
            mimic actually another website named simple. Looking at the design and the concepts I wanted to create a mobile and
             Web responsive app that demonstrates what I can design and bring the idea to life.</p></div>
        </div>
    </div>





    <div className='simple-case-overview-wrapper'>
        <div><h3> Project Statement</h3></div>

        <div className='simple-case-text-wrapper'>
            <div><p>  There were issues building and using other concepts for the user to have a great experience.
            Needed to connect to the Mongo DB database to retrieve information such as the user  registration, login, orders, reviews, etc
            The solution was to have the project be completed that more of a shoe e-commerce type of 
            website that's mobile design, friendly and responsive, web design</p></div>
        </div>
    </div>






    <div className='simple-case-overview-wrapper'>
        <div><h3> Tech Stack</h3></div>

        <div className='simple-case-text-wrapper'>
            <div><p> Languages Used | Frameworks | Tools - JavaScript, Stipe Payment, MongoDB Database, React JS, Node & Express  </p></div>
        </div>
    </div>


    



    <div className='simple-case-overview-wrapper'>
        <div><h3> Challenges & Learnings </h3></div>

        <div className='simple-case-text-wrapper'>
            <div><p>  the challenges were from so many different angles, such as cart functionality, integrating striped payment, 
            Making sure that the local storage and cookies were stored correctly, security on the server was intact with the client side.
            This project helped me learn how to keep things in order and organize for different task in different areas of the project.  </p></div>
        </div>
    </div>




    <div className='simple-case-overview-wrapper'>
        <div><h3> Outcome & Impact  </h3></div>

        <div className='simple-case-text-wrapper'>
            <div><p> The outcome was great because the user is able to have a real similar e-commerce 
            experience once they login and pass validation on the website. Their name will be displayed at the top right on the navbar, 
            which is the authorization navbar. What's the user is logged in. The impact on a
             community I hope is to see the design skills and ideas that I have. </p></div>
        </div>
    </div>







    </div>








    </>
  )
}

export default SimpleCaseStudy
